import req from '../req'
// 商品佣金设置

// 获取商品列表
export function getGoodsList (params) {
  return req.get('/goods/item', params)
}

// 获取商品导购分佣配置
export function getGoodsProfit (goodsid, params) {
  return req.get('/goods/profit/' + goodsid, params)
}

// 保存获取商品导购分佣配置
export function setGoodsProfit (goodsid, params) {
  return req.post('/goods/profit/save/' + goodsid, params)
}
